import React, { Suspense } from "react";
import { createBrowserRouter, Navigate } from "react-router";
import { LayoutArea } from "shared/components/page_layout/layoutarea.component";
import { NotFoundComponent } from "shared/components/error_handling/not_found.component";
import AccessControlGuard from "shared/guards/accesscontrol.guard";
import { UserRole } from "authentication/userrole";
import { SpinnerComponent } from "shared/components/spinner/spinner.component";
import { ROUTES } from "./routes";

const LazyProductsComponent = React.lazy(() =>
  import("./products/products.component").then((m) => ({
    default: m.ProductsComponent,
  })),
);
const LazyProductPropertiesOverviewComponent = React.lazy(() =>
  import("./products/productProperties/overview/productPropertiesOverview.component").then(
    (m) => ({ default: m.ProductPropertiesOverviewComponent }),
  ),
);
const LazyValueSetsOverviewComponent = React.lazy(() =>
  import("./products/valueSets/overview/valueSetsOverview.component").then(
    (m) => ({
      default: m.ValueSetsOverviewComponent,
    }),
  ),
);
const LazyValueSetFormContainer = React.lazy(() =>
  import("./products/valueSets/components/valueSetFormContainer.component").then(
    (m) => ({ default: m.ValueSetFormContainer }),
  ),
);
const LazyValueSetHistoryComponent = React.lazy(() =>
  import("./products/valueSets/history/valueSetHistory.component").then(
    (m) => ({ default: m.ValueSetHistoryComponent }),
  ),
);
const LazyViewValueSetVersionComponent = React.lazy(() =>
  import("./products/valueSets/history/viewValueSetVersion.component").then(
    (m) => ({ default: m.ViewValueSetVersionComponent }),
  ),
);
const LazyFormulasAndFactorsComponent = React.lazy(() =>
  import("./formulasAndFactors/formulasAndFactors.component").then((m) => ({
    default: m.FormulasAndFactorsComponent,
  })),
);
const LazyAssetsComponent = React.lazy(() =>
  import("./assets/assets.component").then((m) => ({
    default: m.AssetsComponent,
  })),
);
const LazyMachinesComponent = React.lazy(() =>
  import("./machines/machines.component").then((m) => ({
    default: m.MachinesComponent,
  })),
);
const LazyMeasurementInspectionsComponent = React.lazy(() =>
  import("./measurementInspections/measurementInspections.component").then(
    (m) => ({
      default: m.MeasurementInspectionsComponent,
    }),
  ),
);
const LazyWidthMeasurementInspectionOverviewComponent = React.lazy(() =>
  import("./measurementInspections/widthMeasurementInspection/overview/widthMeasurementInspectionOverview.component").then(
    (m) => ({ default: m.WidthMeasurementInspectionOverviewComponent }),
  ),
);
const LazyPantyTopMeasurementInspectionOverviewComponent = React.lazy(() =>
  import("./measurementInspections/pantyTopMeasurementInspection/overview/pantyTopMeasurementInspectionOverview.component").then(
    (m) => ({ default: m.PantyTopMeasurementInspectionOverviewComponent }),
  ),
);
const LazyPantyTopMeasurementInspectionFormContainer = React.lazy(() =>
  import("./measurementInspections/pantyTopMeasurementInspection/components/pantyTopMeasurementInspectionFormContainer.component").then(
    (m) => ({ default: m.PantyTopMeasurementInspectionFormContainer }),
  ),
);
const LazyPantyTopMeasurementInspectionHistoryComponent = React.lazy(() =>
  import("./measurementInspections/pantyTopMeasurementInspection/history/pantyTopMeasurementInspectionHistory.component").then(
    (m) => ({ default: m.PantyTopMeasurementInspectionHistoryComponent }),
  ),
);
const LazyViewPantyTopMeasurementInspectionVersionComponent = React.lazy(() =>
  import("./measurementInspections/pantyTopMeasurementInspection/history/viewPantyTopMeasurementInspectionVersion.component").then(
    (m) => ({ default: m.ViewPantyTopMeasurementInspectionVersionComponent }),
  ),
);
const LazyWidthMeasurementInspectionFormContainer = React.lazy(() =>
  import("./measurementInspections/widthMeasurementInspection/components/widthMeasurementInspectionFormContainer.component").then(
    (m) => ({ default: m.WidthMeasurementInspectionFormContainer }),
  ),
);
const LazyWidthMeasurementInspectionHistoryComponent = React.lazy(() =>
  import("./measurementInspections/widthMeasurementInspection/history/widthMeasurementInspectionHistory.component").then(
    (m) => ({ default: m.WidthMeasurementInspectionHistoryComponent }),
  ),
);
const LazyViewWidthMeasurementInspectionVersionComponent = React.lazy(() =>
  import("./measurementInspections/widthMeasurementInspection/history/viewWidthMeasurementInspectionVersion.component").then(
    (m) => ({ default: m.ViewWidthMeasurementInspectionVersionComponent }),
  ),
);
const LazyLengthMeasurementInspectionOverviewComponent = React.lazy(() =>
  import("./measurementInspections/lengthMeasurementInspection/overview/lengthMeasurementInspectionOverview.component").then(
    (m) => ({ default: m.LengthMeasurementInspectionOverviewComponent }),
  ),
);
const LazyLengthMeasurementInspectionFormContainer = React.lazy(() =>
  import("./measurementInspections/lengthMeasurementInspection/components/lengthMeasurementInspectionFormContainer.component").then(
    (m) => ({ default: m.LengthMeasurementInspectionFormContainer }),
  ),
);
const LazyLengthMeasurementInspectionHistoryComponent = React.lazy(() =>
  import("./measurementInspections/lengthMeasurementInspection/history/lengthMeasurementInspectionHistory.component").then(
    (m) => ({ default: m.LengthMeasurementInspectionHistoryComponent }),
  ),
);
const LazyViewLengthMeasurementInspectionVersionComponent = React.lazy(() =>
  import("./measurementInspections/lengthMeasurementInspection/history/viewLengthMeasurementInspectionVersion.component").then(
    (m) => ({ default: m.ViewLengthMeasurementInspectionVersionComponent }),
  ),
);
const LazyMachineAssignmentOverviewComponent = React.lazy(() =>
  import("./machines/machineAssignment/overview/machineAssignmentOverview.component").then(
    (m) => ({
      default: m.MachineAssignmentOverviewComponent,
    }),
  ),
);
const LazyMachineFormContainer = React.lazy(() =>
  import("./machines/machineAssignment/components/machineFormContainer.component").then(
    (m) => ({
      default: m.MachineFormContainer,
    }),
  ),
);
const LazyMachineHistoryComponent = React.lazy(() =>
  import("./machines/machineAssignment/history/machineHistory.component").then(
    (m) => ({ default: m.MachineHistoryComponent }),
  ),
);
const LazyViewMachineVersionComponent = React.lazy(() =>
  import("./machines/machineAssignment/history/viewMachineVersion.component").then(
    (m) => ({ default: m.ViewMachineVersionComponent }),
  ),
);
const LazyWidthMatrixOverviewComponent = React.lazy(() =>
  import("./formulasAndFactors/widthMatrix/overview/widthMatrixOverview.component").then(
    (m) => ({
      default: m.WidthMatrixOverviewComponent,
    }),
  ),
);
const LazyWidthMatrixFormContainer = React.lazy(() =>
  import("./formulasAndFactors/widthMatrix/components/widthMatrixFormContainer.component").then(
    (m) => ({
      default: m.WidthMatrixFormContainer,
    }),
  ),
);
const LazyWidthMatrixHistoryComponent = React.lazy(() =>
  import("./formulasAndFactors/widthMatrix/history/widthMatrixHistory.component").then(
    (m) => ({
      default: m.WidthMatrixHistoryComponent,
    }),
  ),
);
const LazyViewWidthMatrixVersionComponent = React.lazy(() =>
  import("./formulasAndFactors/widthMatrix/history/viewWidthMatrixVersion.component").then(
    (m) => ({
      default: m.ViewWidthMatrixVersionComponent,
    }),
  ),
);
const LazyLengthMatrixOverviewComponent = React.lazy(() =>
  import("./formulasAndFactors/lengthMatrix/overview/lengthMatrixOverview.component").then(
    (m) => ({
      default: m.LengthMatrixOverviewComponent,
    }),
  ),
);
const LazyLengthMatrixFormContainer = React.lazy(() =>
  import("./formulasAndFactors/lengthMatrix/components/lengthMatrixFormContainer.component").then(
    (m) => ({
      default: m.LengthMatrixFormContainer,
    }),
  ),
);
const LazyLengthMatrixHistoryComponent = React.lazy(() =>
  import("./formulasAndFactors/lengthMatrix/history/lengthMatrixHistory.component").then(
    (m) => ({
      default: m.LengthMatrixHistoryComponent,
    }),
  ),
);
const LazyViewLengthMatrixVersionComponent = React.lazy(() =>
  import("./formulasAndFactors/lengthMatrix/history/viewLengthMatrixVersion.component").then(
    (m) => ({
      default: m.ViewLengthMatrixVersionComponent,
    }),
  ),
);

const LazyMeasurementCorrectionOverviewComponent = React.lazy(() =>
  import("./formulasAndFactors/measurementCorrection/overview/measurementCorrectionOverview.component").then(
    (m) => ({
      default: m.MeasurementCorrectionOverviewComponent,
    }),
  ),
);
const LazyMeasurementCorrectionFormContainer = React.lazy(() =>
  import("./formulasAndFactors/measurementCorrection/components/measurementCorrectionFormContainer.component").then(
    (m) => ({
      default: m.MeasurementCorrectionFormContainer,
    }),
  ),
);
const LazyMeasurementCorrectionHistoryComponent = React.lazy(() =>
  import("./formulasAndFactors/measurementCorrection/history/measurementCorrectionHistory.component").then(
    (m) => ({
      default: m.MeasurementCorrectionHistoryComponent,
    }),
  ),
);
const LazyViewMeasurementCorrectionVersionComponent = React.lazy(() =>
  import("./formulasAndFactors/measurementCorrection/history/viewMeasurementCorrectionVersion.component").then(
    (m) => ({
      default: m.ViewMeasurementCorrectionVersionComponent,
    }),
  ),
);
const LazyKnittingSequenceOverviewComponent = React.lazy(() =>
  import("./formulasAndFactors/knittingSequence/overview/knittingSequenceOverview.component").then(
    (m) => ({
      default: m.KnittingSequenceOverviewComponent,
    }),
  ),
);
const LazyKnittingSequenceFormContainer = React.lazy(() =>
  import("./formulasAndFactors/knittingSequence/components/knittingSequenceFormContainer.component").then(
    (m) => ({
      default: m.KnittingSequenceFormContainer,
    }),
  ),
);
const LazyKnittingSequenceHistoryComponent = React.lazy(() =>
  import("./formulasAndFactors/knittingSequence/history/knittingSequenceHistory.component").then(
    (m) => ({
      default: m.KnittingSequenceHistoryComponent,
    }),
  ),
);
const LazyViewKnittingSequenceVersionComponent = React.lazy(() =>
  import("./formulasAndFactors/knittingSequence/history/viewKnittingSequenceVersion.component").then(
    (m) => ({
      default: m.ViewKnittingSequenceVersionComponent,
    }),
  ),
);
const LazyBaseSizeCalculationFormulaOverviewComponent = React.lazy(() =>
  import("./formulasAndFactors/baseSizeCalculationFormula/overview/baseSizeCalculationFormulaOverview.component").then(
    (m) => ({
      default: m.BaseSizeCalculationFormulaOverviewComponent,
    }),
  ),
);
const LazyBaseSizeCalculationFormulaFormContainer = React.lazy(() =>
  import("./formulasAndFactors/baseSizeCalculationFormula/components/baseSizeCalculationFormulaFormContainer.component").then(
    (m) => ({
      default: m.BaseSizeCalculationFormulaFormContainer,
    }),
  ),
);
const LazyMeasurementCalculationFormulaOverviewComponent = React.lazy(() =>
  import("./formulasAndFactors/measurementCalculationFormula/overview/measurementCalculationFormulaOverview.component").then(
    (m) => ({
      default: m.MeasurementCalculationFormulaOverviewComponent,
    }),
  ),
);
const LazyMeasurementCalculationFormulaFormContainer = React.lazy(() =>
  import("./formulasAndFactors/measurementCalculationFormula/components/measurementCalculationFormulaFormContainer.component").then(
    (m) => ({
      default: m.MeasurementCalculationFormulaFormContainer,
    }),
  ),
);

const LazyMeasurementCalculationFormulaHistoryComponent = React.lazy(() =>
  import("./formulasAndFactors/measurementCalculationFormula/history/measurementCalculationFormulaHistory.component").then(
    (m) => ({
      default: m.MeasurementCalculationFormulaHistoryComponent,
    }),
  ),
);
const LazyViewMeasurementCalculationFormulaVersionComponent = React.lazy(() =>
  import("./formulasAndFactors/measurementCalculationFormula/history/viewMeasurementCalculationFormulaVersion.component").then(
    (m) => ({
      default: m.ViewMeasurementCalculationFormulaVersionComponent,
    }),
  ),
);
const LazyBaseSizeCalculationFormulaHistoryComponent = React.lazy(() =>
  import("./formulasAndFactors/baseSizeCalculationFormula/history/baseSizeCalculationFormulaHistory.component").then(
    (m) => ({
      default: m.BaseSizeCalculationFormulaHistoryComponent,
    }),
  ),
);
const LazyViewBaseSizeCalculationFormulaVersionComponent = React.lazy(() =>
  import("./formulasAndFactors/baseSizeCalculationFormula/history/viewBaseSizeCalculationFormulaVersion.component").then(
    (m) => ({
      default: m.ViewBaseSizeCalculationFormulaVersionComponent,
    }),
  ),
);
const LazyKnittingProgramLibraryOverviewComponent = React.lazy(() =>
  import("./assets/knittingProgramLibrary/overview/knittingProgramLibraryOverview.component").then(
    (m) => ({ default: m.KnittingProgramLibraryOverviewComponent }),
  ),
);
const LazyKnittingProgramLibraryFormContainer = React.lazy(() =>
  import("./assets/knittingProgramLibrary/components/knittingProgramLibraryFormContainer.component").then(
    (m) => ({ default: m.KnittingProgramLibraryFormContainer }),
  ),
);
const LazyKnittingProgramUploadComponent = React.lazy(() =>
  import("./assets/knittingProgramLibrary/upload/knittingProgramUpload.component").then(
    (m) => ({ default: m.KnittingProgramUploadComponent }),
  ),
);
const LazyLibraryVersionHistoryComponent = React.lazy(() =>
  import("./assets/knittingProgramLibrary/versionHistory/libraryVersionHistory.component").then(
    (m) => ({ default: m.LibraryVersionHistoryComponent }),
  ),
);
const LazyProgramVersionHistoryComponent = React.lazy(() =>
  import("./assets/knittingProgramLibrary/versionHistory/programVersionHistory.component").then(
    (m) => ({ default: m.ProgramVersionHistoryComponent }),
  ),
);
const LazyMeasurementCalculationFactorOverviewComponent = React.lazy(() =>
  import("./formulasAndFactors/measurementCalculationFactor/overview/measurementCalculationFactorOverview.component").then(
    (m) => ({
      default: m.MeasurementCalculationFactorOverviewComponent,
    }),
  ),
);
const LazyMeasurementCalculationFactorFormContainer = React.lazy(() =>
  import("./formulasAndFactors/measurementCalculationFactor/components/measurementCalculationFactorFormContainer.component").then(
    (m) => ({
      default: m.MeasurementCalculationFactorFormContainer,
    }),
  ),
);

const LazyPatternProgramsOverviewComponent = React.lazy(() =>
  import("./assets/patternPrograms/overview/patternProgramsOverview.component").then(
    (m) => ({ default: m.PatternProgramsOverviewComponent }),
  ),
);
const LazyPatternProgramHistoryComponent = React.lazy(() =>
  import("./assets/patternPrograms/history/patternProgramHistory.component").then(
    (m) => ({ default: m.PatternProgramHistoryComponent }),
  ),
);
const LazyPatternProgramFormContainer = React.lazy(() =>
  import("./assets/patternPrograms/components/patternProgramFormContainer.component").then(
    (m) => ({ default: m.PatternProgramFormContainer }),
  ),
);

const LazyMiniProgramsOverviewComponent = React.lazy(() =>
  import("./assets/miniPrograms/overview/miniProgramsOverview.component").then(
    (m) => ({ default: m.MiniProgramsOverviewComponent }),
  ),
);
const LazyMiniProgramHistoryComponent = React.lazy(() =>
  import("./assets/miniPrograms/history/miniProgramHistory.component").then(
    (m) => ({ default: m.MiniProgramHistoryComponent }),
  ),
);
const LazyMiniProgramFormContainer = React.lazy(() =>
  import("./assets/miniPrograms/components/miniProgramFormContainer.component").then(
    (m) => ({ default: m.MiniProgramFormContainer }),
  ),
);
const LazyPantyTopProgramsOverviewComponent = React.lazy(() =>
  import("./assets/pantyTopPrograms/overview/pantyTopProgramsOverview.component").then(
    (module) => ({ default: module.PantyTopProgramsOverviewComponent }),
  ),
);
const LazyPantyTopProgramHistoryComponent = React.lazy(() =>
  import("./assets/pantyTopPrograms/history/pantyTopProgramHistory.component").then(
    (module) => ({ default: module.PantyTopProgramHistoryComponent }),
  ),
);
const LazyPantyTopProgramFormContainer = React.lazy(() =>
  import("./assets/pantyTopPrograms/components/pantyTopProgramFormContainer.component").then(
    (module) => ({ default: module.PantyTopProgramFormContainer }),
  ),
);
const LazyMeasurementCalculationFactorHistoryComponent = React.lazy(() =>
  import("./formulasAndFactors/measurementCalculationFactor/history/measurementCalculationFactorHistory.component").then(
    (m) => ({
      default: m.MeasurementCalculationFactorHistoryComponent,
    }),
  ),
);
const LazyViewMeasurementCalculationFactorVersionComponent = React.lazy(() =>
  import("./formulasAndFactors/measurementCalculationFactor/history/viewMeasurementCalculationFactorVersion.component").then(
    (m) => ({
      default: m.ViewMeasurementCalculationFactorVersionComponent,
    }),
  ),
);

const withSuspense = (element: React.ReactNode) => (
  <Suspense fallback={<SpinnerComponent />}>{element}</Suspense>
);

export const router = createBrowserRouter([
  {
    path: "/",
    element: <LayoutArea />,
    children: [
      {
        index: true,
        element: <Navigate replace to={ROUTES.PRODUCTS} />,
      },
      {
        path: "products",
        handle: { breadcrumb: "Breadcrumb_ProductionMasterData" },
        element: (
          <AccessControlGuard allowedRoles={[UserRole.MrsViewer]}>
            {withSuspense(<LazyProductsComponent />)}
          </AccessControlGuard>
        ),
        children: [
          {
            path: "product-properties",
            handle: {
              breadcrumb: "Breadcrumb_ProductionMasterData_ProductProperties",
            },
            element: withSuspense(<LazyProductPropertiesOverviewComponent />),
          },
          {
            path: "value-sets",
            handle: {
              breadcrumb: "Breadcrumb_ProductionMasterData_ValueSets",
            },
            element: withSuspense(<LazyValueSetsOverviewComponent />),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb:
                    "Breadcrumb_ProductionMasterData_ValueSets_Create",
                },
                element: withSuspense(
                  <LazyValueSetFormContainer formMode="create" />,
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb: "Breadcrumb_ProductionMasterData_ValueSets_Edit",
                },
                element: withSuspense(
                  <LazyValueSetFormContainer formMode="update" />,
                ),
              },
              {
                path: ":id/history",
                handle: {
                  breadcrumb: "Breadcrumb_History",
                },
                children: [
                  {
                    index: true,
                    element: withSuspense(<LazyValueSetHistoryComponent />),
                  },
                  {
                    path: ":version",
                    handle: {
                      breadcrumb: "Breadcrumb_History_Version",
                    },
                    element: withSuspense(<LazyViewValueSetVersionComponent />),
                  },
                ],
              },
              {
                path: ":id/duplicate",
                handle: {
                  breadcrumb: "Breadcrumb_Duplicate",
                },
                element: withSuspense(<LazyValueSetFormContainer />),
              },
            ],
          },

          {
            path: "*",
            element: <NotFoundComponent />,
          },
        ],
      },
      {
        path: "formulasAndFactors",
        handle: { breadcrumb: "Breadcrumb_FormulasAndFactors" },
        element: (
          <AccessControlGuard allowedRoles={[UserRole.MrsViewer]}>
            {withSuspense(<LazyFormulasAndFactorsComponent />)}
          </AccessControlGuard>
        ),
        children: [
          {
            path: "widthMatrix",
            handle: { breadcrumb: "Breadcrumb_FormulasAndFactors_WidthMatrix" },
            element: withSuspense(<LazyWidthMatrixOverviewComponent />),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb:
                    "Breadcrumb_FormulasAndFactors_WidthMatrix_Create",
                },
                element: withSuspense(
                  <LazyWidthMatrixFormContainer formMode="create" />,
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb: "Breadcrumb_FormulasAndFactors_WidthMatrix_Edit",
                },
                element: withSuspense(
                  <LazyWidthMatrixFormContainer formMode="update" />,
                ),
              },
              {
                path: ":id/history",
                handle: {
                  breadcrumb: "Breadcrumb_History",
                },
                children: [
                  {
                    index: true,
                    element: withSuspense(<LazyWidthMatrixHistoryComponent />),
                  },
                  {
                    path: ":version",
                    handle: {
                      breadcrumb: "Breadcrumb_History_Version",
                    },
                    element: withSuspense(
                      <LazyViewWidthMatrixVersionComponent />,
                    ),
                  },
                ],
              },
              {
                path: ":id/duplicate",
                handle: {
                  breadcrumb: "Breadcrumb_Duplicate",
                },
                element: withSuspense(<LazyWidthMatrixFormContainer />),
              },
            ],
          },
          {
            path: "lengthMatrix",
            handle: {
              breadcrumb: "Breadcrumb_FormulasAndFactors_LengthMatrix",
            },
            element: withSuspense(<LazyLengthMatrixOverviewComponent />),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb:
                    "Breadcrumb_FormulasAndFactors_LengthMatrix_Create",
                },
                element: withSuspense(
                  <LazyLengthMatrixFormContainer formMode="create" />,
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb: "Breadcrumb_FormulasAndFactors_LengthMatrix_Edit",
                },
                element: withSuspense(
                  <LazyLengthMatrixFormContainer formMode="update" />,
                ),
              },
              {
                path: ":id/history",
                handle: {
                  breadcrumb: "Breadcrumb_History",
                },
                children: [
                  {
                    index: true,
                    element: withSuspense(<LazyLengthMatrixHistoryComponent />),
                  },
                  {
                    path: ":version",
                    handle: {
                      breadcrumb: "Breadcrumb_History_Version",
                    },
                    element: withSuspense(
                      <LazyViewLengthMatrixVersionComponent />,
                    ),
                  },
                ],
              },
              {
                path: ":id/duplicate",
                handle: {
                  breadcrumb: "Breadcrumb_Duplicate",
                },
                element: withSuspense(<LazyLengthMatrixFormContainer />),
              },
            ],
          },
          {
            path: "measurementCorrection",
            handle: {
              breadcrumb: "Breadcrumb_FormulasAndFactors_MeasurementCorrection",
            },
            element: withSuspense(
              <LazyMeasurementCorrectionOverviewComponent />,
            ),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb:
                    "Breadcrumb_FormulasAndFactors_MeasurementCorrection_Create",
                },
                element: withSuspense(
                  <LazyMeasurementCorrectionFormContainer formMode="create" />,
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb:
                    "Breadcrumb_FormulasAndFactors_MeasurementCorrection_Edit",
                },
                element: withSuspense(
                  <LazyMeasurementCorrectionFormContainer formMode="update" />,
                ),
              },
              {
                path: ":id/history",
                handle: {
                  breadcrumb: "Breadcrumb_History",
                },
                children: [
                  {
                    index: true,
                    element: withSuspense(
                      <LazyMeasurementCorrectionHistoryComponent />,
                    ),
                  },
                  {
                    path: ":version",
                    handle: {
                      breadcrumb: "Breadcrumb_History_Version",
                    },
                    element: withSuspense(
                      <LazyViewMeasurementCorrectionVersionComponent />,
                    ),
                  },
                ],
              },
              {
                path: ":id/duplicate",
                handle: {
                  breadcrumb: "Breadcrumb_Duplicate",
                },
                element: withSuspense(
                  <LazyMeasurementCorrectionFormContainer />,
                ),
              },
            ],
          },
          {
            path: "knittingSequence",
            handle: {
              breadcrumb: "Breadcrumb_FormulasAndFactors_KnittingSequence",
            },
            element: withSuspense(<LazyKnittingSequenceOverviewComponent />),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb:
                    "Breadcrumb_FormulasAndFactors_KnittingSequence_Create",
                },
                element: withSuspense(
                  <LazyKnittingSequenceFormContainer formMode="create" />,
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb:
                    "Breadcrumb_FormulasAndFactors_KnittingSequence_Edit",
                },
                element: withSuspense(
                  <LazyKnittingSequenceFormContainer formMode="update" />,
                ),
              },
              {
                path: ":id/history",
                handle: {
                  breadcrumb: "Breadcrumb_History",
                },
                children: [
                  {
                    index: true,
                    element: withSuspense(
                      <LazyKnittingSequenceHistoryComponent />,
                    ),
                  },
                  {
                    path: ":version",
                    handle: {
                      breadcrumb: "Breadcrumb_History_Version",
                    },
                    element: withSuspense(
                      <LazyViewKnittingSequenceVersionComponent />,
                    ),
                  },
                ],
              },
              {
                path: ":id/duplicate",
                handle: {
                  breadcrumb: "Breadcrumb_Duplicate",
                },
                element: withSuspense(<LazyKnittingSequenceFormContainer />),
              },
            ],
          },
          {
            path: "baseSizeCalculationFormula",
            handle: {
              breadcrumb:
                "Breadcrumb_FormulasAndFactors_BaseSizeCalculationFormula",
            },
            element: withSuspense(
              <LazyBaseSizeCalculationFormulaOverviewComponent />,
            ),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb:
                    "Breadcrumb_FormulasAndFactors_BaseSizeCalculationFormula_Create",
                },
                element: withSuspense(
                  <LazyBaseSizeCalculationFormulaFormContainer formMode="create" />,
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb:
                    "Breadcrumb_FormulasAndFactors_BaseSizeCalculationFormula_Edit",
                },
                element: withSuspense(
                  <LazyBaseSizeCalculationFormulaFormContainer formMode="update" />,
                ),
              },
              {
                path: ":id/history",
                handle: {
                  breadcrumb: "Breadcrumb_History",
                },
                children: [
                  {
                    index: true,
                    element: withSuspense(
                      <LazyBaseSizeCalculationFormulaHistoryComponent />,
                    ),
                  },
                  {
                    path: ":version",
                    handle: {
                      breadcrumb: "Breadcrumb_History_Version",
                    },
                    element: withSuspense(
                      <LazyViewBaseSizeCalculationFormulaVersionComponent />,
                    ),
                  },
                ],
              },
              {
                path: ":id/duplicate",
                handle: {
                  breadcrumb: "Breadcrumb_Duplicate",
                },
                element: withSuspense(
                  <LazyBaseSizeCalculationFormulaFormContainer />,
                ),
              },
            ],
          },
          {
            path: "measurementCalculationFactor",
            handle: {
              breadcrumb:
                "Breadcrumb_FormulasAndFactors_MeasurementCalculationFactor",
            },
            element: withSuspense(
              <LazyMeasurementCalculationFactorOverviewComponent />,
            ),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb:
                    "Breadcrumb_FormulasAndFactors_MeasurementCalculationFactor_Create",
                },
                element: withSuspense(
                  <LazyMeasurementCalculationFactorFormContainer formMode="create" />,
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb:
                    "Breadcrumb_FormulasAndFactors_MeasurementCalculationFactor_Edit",
                },
                element: withSuspense(
                  <LazyMeasurementCalculationFactorFormContainer formMode="update" />,
                ),
              },
              {
                path: ":id/history",
                handle: {
                  breadcrumb: "Breadcrumb_History",
                },
                children: [
                  {
                    index: true,
                    element: withSuspense(
                      <LazyMeasurementCalculationFactorHistoryComponent />,
                    ),
                  },
                  {
                    path: ":version",
                    handle: {
                      breadcrumb: "Breadcrumb_History_Version",
                    },
                    element: withSuspense(
                      <LazyViewMeasurementCalculationFactorVersionComponent />,
                    ),
                  },
                ],
              },
              {
                path: ":id/duplicate",
                handle: {
                  breadcrumb: "Breadcrumb_Duplicate",
                },
                element: withSuspense(
                  <LazyMeasurementCalculationFactorFormContainer />,
                ),
              },
            ],
          },
          {
            path: "measurementCalculationFormula",
            handle: {
              breadcrumb:
                "Breadcrumb_FormulasAndFactors_MeasurementCalculationFormula",
            },
            element: withSuspense(
              <LazyMeasurementCalculationFormulaOverviewComponent />,
            ),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb:
                    "Breadcrumb_FormulasAndFactors_MeasurementCalculationFormula_Create",
                },
                element: withSuspense(
                  <LazyMeasurementCalculationFormulaFormContainer formMode="create" />,
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb:
                    "Breadcrumb_FormulasAndFactors_MeasurementCalculationFormula_Edit",
                },
                element: withSuspense(
                  <LazyMeasurementCalculationFormulaFormContainer formMode="update" />,
                ),
              },
              {
                path: ":id/history",
                handle: {
                  breadcrumb: "Breadcrumb_History",
                },
                children: [
                  {
                    index: true,
                    element: withSuspense(
                      <LazyMeasurementCalculationFormulaHistoryComponent />,
                    ),
                  },
                  {
                    path: ":version",
                    handle: {
                      breadcrumb: "Breadcrumb_History_Version",
                    },
                    element: withSuspense(
                      <LazyViewMeasurementCalculationFormulaVersionComponent />,
                    ),
                  },
                ],
              },
              {
                path: ":id/duplicate",
                handle: {
                  breadcrumb: "Breadcrumb_Duplicate",
                },
                element: withSuspense(
                  <LazyMeasurementCalculationFormulaFormContainer />,
                ),
              },
            ],
          },
          {
            path: "*",
            element: <NotFoundComponent />,
          },
        ],
      },
      {
        path: "assets",
        handle: { breadcrumb: "Breadcrumb_Assets" },
        element: (
          <AccessControlGuard
            allowedRoles={[UserRole.MrsViewer, UserRole.MrsEditor]}
          >
            {withSuspense(<LazyAssetsComponent />)}
          </AccessControlGuard>
        ),
        children: [
          {
            path: "knittingProgramLibrary",
            handle: {
              breadcrumb: "Breadcrumb_Assets_KnittingProgramLibrary",
            },
            element: withSuspense(
              <LazyKnittingProgramLibraryOverviewComponent />,
            ),
            children: [
              {
                path: "create",
                element: (
                  <AccessControlGuard
                    allowedRoles={[UserRole.MrsEditor]}
                    fallback={
                      <Navigate
                        replace
                        to={ROUTES.ASSETS_KNITTING_PROGRAM_LIBRARY}
                      />
                    }
                  >
                    {withSuspense(<LazyKnittingProgramLibraryFormContainer />)}
                  </AccessControlGuard>
                ),
              },
              {
                path: ":id/edit",
                element: withSuspense(
                  <LazyKnittingProgramLibraryFormContainer />,
                ),
              },
              {
                path: ":id/upload",
                element: (
                  <AccessControlGuard
                    allowedRoles={[UserRole.MrsEditor]}
                    fallback={
                      <Navigate
                        replace
                        to={ROUTES.ASSETS_KNITTING_PROGRAM_LIBRARY}
                      />
                    }
                  >
                    {withSuspense(<LazyKnittingProgramUploadComponent />)}
                  </AccessControlGuard>
                ),
              },
              {
                path: ":id/history",
                element: withSuspense(<LazyLibraryVersionHistoryComponent />),
              },
              {
                path: "programs/:programId/history",
                element: withSuspense(<LazyProgramVersionHistoryComponent />),
              },
            ],
          },
          {
            path: "patternPrograms",
            handle: { breadcrumb: "Breadcrumb_Assets_PatternPrograms" },
            element: withSuspense(<LazyPatternProgramsOverviewComponent />),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb: "Breadcrumb_Assets_PatternPrograms_Create",
                },
                element: (
                  <AccessControlGuard
                    allowedRoles={[UserRole.MrsEditor]}
                    fallback={
                      <Navigate replace to={ROUTES.ASSETS_PATTERN_PROGRAMS} />
                    }
                  >
                    {withSuspense(
                      <LazyPatternProgramFormContainer mode="create" />,
                    )}
                  </AccessControlGuard>
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb: "Breadcrumb_Assets_PatternPrograms_Edit",
                },
                element: (
                  <AccessControlGuard
                    allowedRoles={[UserRole.MrsEditor]}
                    fallback={
                      <Navigate replace to={ROUTES.ASSETS_PATTERN_PROGRAMS} />
                    }
                  >
                    {withSuspense(
                      <LazyPatternProgramFormContainer mode="edit" />,
                    )}
                  </AccessControlGuard>
                ),
              },
              {
                path: ":id/history",
                handle: { breadcrumb: "Breadcrumb_History" },
                element: withSuspense(<LazyPatternProgramHistoryComponent />),
              },
            ],
          },
          {
            path: "miniPrograms",
            handle: { breadcrumb: "Breadcrumb_Assets_MiniPrograms" },
            element: withSuspense(<LazyMiniProgramsOverviewComponent />),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb: "Breadcrumb_Assets_MiniPrograms_Create",
                },
                element: (
                  <AccessControlGuard
                    allowedRoles={[UserRole.MrsEditor]}
                    fallback={
                      <Navigate replace to={ROUTES.ASSETS_MINI_PROGRAMS} />
                    }
                  >
                    {withSuspense(
                      <LazyMiniProgramFormContainer mode="create" />,
                    )}
                  </AccessControlGuard>
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb: "Breadcrumb_Assets_MiniPrograms_Edit",
                },
                element: (
                  <AccessControlGuard
                    allowedRoles={[UserRole.MrsEditor]}
                    fallback={
                      <Navigate replace to={ROUTES.ASSETS_MINI_PROGRAMS} />
                    }
                  >
                    {withSuspense(<LazyMiniProgramFormContainer mode="edit" />)}
                  </AccessControlGuard>
                ),
              },
              {
                path: ":id/history",
                handle: { breadcrumb: "Breadcrumb_History" },
                element: withSuspense(<LazyMiniProgramHistoryComponent />),
              },
            ],
          },
          {
            path: "pantyTopPrograms",
            handle: { breadcrumb: "Breadcrumb_Assets_PantyTopPrograms" },
            element: withSuspense(<LazyPantyTopProgramsOverviewComponent />),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb: "Breadcrumb_Assets_PantyTopPrograms_Create",
                },
                element: (
                  <AccessControlGuard
                    allowedRoles={[UserRole.MrsEditor]}
                    fallback={
                      <Navigate replace to={ROUTES.ASSETS_PANTY_TOP_PROGRAMS} />
                    }
                  >
                    {withSuspense(
                      <LazyPantyTopProgramFormContainer mode="create" />,
                    )}
                  </AccessControlGuard>
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb: "Breadcrumb_Assets_PantyTopPrograms_Edit",
                },
                element: (
                  <AccessControlGuard
                    allowedRoles={[UserRole.MrsEditor]}
                    fallback={
                      <Navigate replace to={ROUTES.ASSETS_PANTY_TOP_PROGRAMS} />
                    }
                  >
                    {withSuspense(
                      <LazyPantyTopProgramFormContainer mode="edit" />,
                    )}
                  </AccessControlGuard>
                ),
              },
              {
                path: ":id/history",
                handle: { breadcrumb: "Breadcrumb_History" },
                element: withSuspense(<LazyPantyTopProgramHistoryComponent />),
              },
            ],
          },
          {
            path: "*",
            element: <NotFoundComponent />,
          },
        ],
      },
      {
        path: "machines",
        handle: { breadcrumb: "Breadcrumb_Machines" },
        element: (
          <AccessControlGuard allowedRoles={[UserRole.MrsViewer]}>
            {withSuspense(<LazyMachinesComponent />)}
          </AccessControlGuard>
        ),
        children: [
          {
            path: "machineAssignment",
            handle: {
              breadcrumb: "Breadcrumb_Machines_MachineAssignment",
            },
            element: withSuspense(<LazyMachineAssignmentOverviewComponent />),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb: "Breadcrumb_Machines_MachineAssignment_Create",
                },
                element: withSuspense(
                  <LazyMachineFormContainer formMode="create" />,
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb: "Breadcrumb_Machines_MachineAssignment_Edit",
                },
                element: withSuspense(
                  <LazyMachineFormContainer formMode="update" />,
                ),
              },
              {
                path: ":id/history",
                handle: {
                  breadcrumb: "Breadcrumb_History",
                },
                children: [
                  {
                    index: true,
                    element: withSuspense(<LazyMachineHistoryComponent />),
                  },
                  {
                    path: ":version",
                    handle: {
                      breadcrumb: "Breadcrumb_History_Version",
                    },
                    element: withSuspense(<LazyViewMachineVersionComponent />),
                  },
                ],
              },
              {
                path: ":id/duplicate",
                handle: {
                  breadcrumb: "Breadcrumb_Duplicate",
                },
                element: withSuspense(<LazyMachineFormContainer />),
              },
            ],
          },
          {
            path: "*",
            element: <NotFoundComponent />,
          },
        ],
      },
      {
        path: "measurementInspections",
        handle: { breadcrumb: "Breadcrumb_MeasurementInspections" },
        element: (
          <AccessControlGuard allowedRoles={[UserRole.MrsViewer]}>
            {withSuspense(<LazyMeasurementInspectionsComponent />)}
          </AccessControlGuard>
        ),
        children: [
          {
            path: "pantyTopMeasurementInspection",
            handle: {
              breadcrumb:
                "Breadcrumb_MeasurementInspections_PantyTopMeasurementInspection",
            },
            element: withSuspense(
              <LazyPantyTopMeasurementInspectionOverviewComponent />,
            ),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb:
                    "Breadcrumb_MeasurementInspections_PantyTopMeasurementInspection_Create",
                },
                element: withSuspense(
                  <LazyPantyTopMeasurementInspectionFormContainer formMode="create" />,
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb:
                    "Breadcrumb_MeasurementInspections_PantyTopMeasurementInspection_Edit",
                },
                element: withSuspense(
                  <LazyPantyTopMeasurementInspectionFormContainer formMode="update" />,
                ),
              },
              {
                path: ":id/duplicate",
                handle: { breadcrumb: "Breadcrumb_Duplicate" },
                element: withSuspense(
                  <LazyPantyTopMeasurementInspectionFormContainer />,
                ),
              },
              {
                path: ":id/history",
                handle: { breadcrumb: "Breadcrumb_History" },
                children: [
                  {
                    index: true,
                    element: withSuspense(
                      <LazyPantyTopMeasurementInspectionHistoryComponent />,
                    ),
                  },
                  {
                    path: ":version",
                    handle: { breadcrumb: "Breadcrumb_History_Version" },
                    element: withSuspense(
                      <LazyViewPantyTopMeasurementInspectionVersionComponent />,
                    ),
                  },
                ],
              },
            ],
          },
          {
            path: "widthMeasurementInspection",
            handle: {
              breadcrumb:
                "Breadcrumb_MeasurementInspections_WidthMeasurementInspection",
            },
            element: withSuspense(
              <LazyWidthMeasurementInspectionOverviewComponent />,
            ),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb:
                    "Breadcrumb_MeasurementInspections_WidthMeasurementInspection_Create",
                },
                element: withSuspense(
                  <LazyWidthMeasurementInspectionFormContainer formMode="create" />,
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb:
                    "Breadcrumb_MeasurementInspections_WidthMeasurementInspection_Edit",
                },
                element: withSuspense(
                  <LazyWidthMeasurementInspectionFormContainer formMode="update" />,
                ),
              },
              {
                path: ":id/duplicate",
                handle: {
                  breadcrumb: "Breadcrumb_Duplicate",
                },
                element: withSuspense(
                  <LazyWidthMeasurementInspectionFormContainer />,
                ),
              },
              {
                path: ":id/history",
                handle: {
                  breadcrumb: "Breadcrumb_History",
                },
                children: [
                  {
                    index: true,
                    element: withSuspense(
                      <LazyWidthMeasurementInspectionHistoryComponent />,
                    ),
                  },
                  {
                    path: ":version",
                    handle: {
                      breadcrumb: "Breadcrumb_History_Version",
                    },
                    element: withSuspense(
                      <LazyViewWidthMeasurementInspectionVersionComponent />,
                    ),
                  },
                ],
              },
            ],
          },
          {
            path: "lengthMeasurementInspection",
            handle: {
              breadcrumb:
                "Breadcrumb_MeasurementInspections_LengthMeasurementInspection",
            },
            element: withSuspense(
              <LazyLengthMeasurementInspectionOverviewComponent />,
            ),
            children: [
              {
                path: "create",
                handle: {
                  breadcrumb:
                    "Breadcrumb_MeasurementInspections_LengthMeasurementInspection_Create",
                },
                element: withSuspense(
                  <LazyLengthMeasurementInspectionFormContainer formMode="create" />,
                ),
              },
              {
                path: ":id/edit",
                handle: {
                  breadcrumb:
                    "Breadcrumb_MeasurementInspections_LengthMeasurementInspection_Edit",
                },
                element: withSuspense(
                  <LazyLengthMeasurementInspectionFormContainer formMode="update" />,
                ),
              },
              {
                path: ":id/duplicate",
                handle: {
                  breadcrumb: "Breadcrumb_Duplicate",
                },
                element: withSuspense(
                  <LazyLengthMeasurementInspectionFormContainer />,
                ),
              },
              {
                path: ":id/history",
                handle: {
                  breadcrumb: "Breadcrumb_History",
                },
                children: [
                  {
                    index: true,
                    element: withSuspense(
                      <LazyLengthMeasurementInspectionHistoryComponent />,
                    ),
                  },
                  {
                    path: ":version",
                    handle: {
                      breadcrumb: "Breadcrumb_History_Version",
                    },
                    element: withSuspense(
                      <LazyViewLengthMeasurementInspectionVersionComponent />,
                    ),
                  },
                ],
              },
            ],
          },
          {
            path: "*",
            element: <NotFoundComponent />,
          },
        ],
      },
      {
        path: "*",
        element: <NotFoundComponent />,
      },
    ],
  },
]);
